/** This code hides the left column of the steal this deck form on successul submission.
 * It'll also widen up the confirmation to 12 cols :)
 */
jQuery(document).on('gform_confirmation_loaded', function (event, formId) {
    $('#gform_confirmation_wrapper_' + formId).closest('.steal-form').find('.file-info-form').addClass('cols-sm-12').removeClass('col-sm-6');
    $('#gform_confirmation_wrapper_' + formId).closest('.steal-form').find('.col-sm-6:first').hide();
});